import {
  GET_USER_ID,
  GET_PAYMENT_HISTORY,
  GET_SCHEDULED_PAYMENT,
  GET_TRANSACTIONS_HISTORY,
  GET_CONTRACTS,
  GET_ACTIVE_TAB,
  GET_NOTIFICATIONS,
  GET_CUSTOMER_INFORMATION,
  GET_CUSTOMER_DETAILS,
  GET_INPROGRESS_PAYMENTS,
  GET_OTP,
  GET_USER_DETAIL,
  GET_ASSET_INFORMATION,
  GET_MACHINE_HEALTH_DETAILS,
  GET_OFFER_ELIGIBILITY,
  GET_OFFER_ENQUIRY,
  GET_SKIP_TOUR,
  GET_USER_NAME,
  UPDATE_CUSTOMER_DETAILS,
  RESET_PRESERVED_STATE,
  UPDATE_EXPENSE_TOUR_FLAG,
  GET_USER_LOCALE,
  UPDATE_TNC_ACCEPTED,
  LOAD_PERSONAL_OFFER_LETTER_DATA,
  SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY,
  SET_SHOW_HIDE_PERSONAL_OFFER_LETTER,
  SET_USER_SEEN_THE_PERSONAL_OFFER,
  SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD,
  SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD,
  GET_OTP_NON_MFA_USER,
  VERIFY_OTP_NON_MFA_USER,
  FETCH_NON_MFA_USER_PROFILE,
  UPDATE_NON_MFA_WHATSAPP_OPTIN,
  SET_NON_MFA_USER_MOBILE_NUMBER,
  SET_NON_MFA_USER_DATA,
  SET_NON_MFA_ALERT,
  RESET_NON_MFA_ALERT,
  NON_MFA_USER_VERIFICATION_SUCCESS,
  NON_MFA_USER_SUBMIT_OFFER,
  SET_SELECTED_OFFER_NON_MFA_CUSTOMER,
  SET_CUSTOM_ALERT,
  SET_OFFERS_VIEW,
  NON_MFA_SET_VIEW,
  REMOVE_USER_DETAILS,
  LOAD_USER_DEVICE_PUSH_TOKEN,
  ASK_USER_TO_ENABLE_PUSH,
  SET_OFFERS_SUBMIT,
  SET_CONFIRM_PAYMENT_DATA,
  UPDATE_WHATSAPP_OPT_IN_DETAILS,
  UPDATE_POPUP_SEEN_REQUEST,
  GET_ACCOUNTING_PAYMENT_HISTORY,
} from './actionTypes';

export const userIdAction = (data) => {
  return {
    type: GET_USER_ID,
    userId: data,
  };
};

export const paymentHistoryAction = (data) => {
  return {
    type: GET_PAYMENT_HISTORY,
    paymentHistoryData: data,
  };
};

export const scheduledPaymentAction = (data) => {
  return {
    type: GET_SCHEDULED_PAYMENT,
    scheduledPaymentData: data,
  };
};

export const transactionHistoryAction = (data) => {
  return {
    type: GET_TRANSACTIONS_HISTORY,
    transactionsHistoryData: data,
  };
};

export const contractSummaryAction = (data) => {
  return {
    type: GET_CONTRACTS,
    contractData: data,
  };
};

export const inAppNotificationAction = (data) => {
  return {
    type: GET_NOTIFICATIONS,
    inAppNotificationData: data,
  };
};

export const activeTabAction = (data) => {
  return {
    type: GET_ACTIVE_TAB,
    activeTab: data,
  };
};

export const customerInformationAction = (data) => {
  return {
    type: GET_CUSTOMER_INFORMATION,
    customerInformation: data,
  };
};

export const inprogressPayments = (data) => {
  return {
    type: GET_INPROGRESS_PAYMENTS,
    inprogressPayments: data,
  };
};

export const setConfirmPaymentData = (data) => {
  return {
    type: SET_CONFIRM_PAYMENT_DATA,
    confirmPaymentData: data,
  };
};

export const otpAction = (data) => {
  return {
    type: GET_OTP,
    loginOTP: data,
  };
};

export const removeUserDetails = () => {
  return {
    type: REMOVE_USER_DETAILS,
  };
};
export const userDetailAction = (data) => {
  return {
    type: GET_USER_DETAIL,
    userDetail: data,
  };
};

export const assetInformationAction = (data) => {
  return {
    type: GET_ASSET_INFORMATION,
    assetInformationData: data,
  };
};

export const machineHealthDetailsAction = (data) => {
  return {
    type: GET_MACHINE_HEALTH_DETAILS,
    machineHealthDetails: data,
  };
};

export const skipTourAction = (data) => {
  return {
    type: GET_SKIP_TOUR,
    skipTour: data,
  };
};

export const customerDetailsAction = (data) => {
  return {
    type: GET_CUSTOMER_DETAILS,
    customerDetailsData: data,
  };
};

export const userNameAction = (data) => {
  return {
    type: GET_USER_NAME,
    userName: data,
  };
};

export const updateCustomerDetailsAction = () => {
  return {
    type: UPDATE_CUSTOMER_DETAILS,
  };
};

export const updateExpenseTourAction = () => {
  return {
    type: UPDATE_EXPENSE_TOUR_FLAG,
  };
};

export const resetPreserveStateAction = () => {
  return {
    type: RESET_PRESERVED_STATE,
  };
};

export const userLocaleAction = (data) => {
  return {
    type: GET_USER_LOCALE,
    userLocale: data,
  };
};

export const updateTnCAcceptedAction = () => {
  return {
    type: UPDATE_TNC_ACCEPTED,
  };
};

export const loadDataForPersonalOfferLetter = (data) => {
  return {
    type: LOAD_PERSONAL_OFFER_LETTER_DATA,
    data,
  };
};

export const submitRecommendedImplementEnquiry = (data) => {
  return {
    type: SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY,
    data,
  };
};

export const setShowHidePersonalOfferLetter = (data) => {
  return {
    type: SET_SHOW_HIDE_PERSONAL_OFFER_LETTER,
    data,
  };
};

export const setUserScratchTheCard = (data) => {
  return {
    type: SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD,
    data,
  };
};

export const setUserSeenThePersonalOffer = (data) => {
  return {
    type: SET_USER_SEEN_THE_PERSONAL_OFFER,
    data,
  };
};

export const setUserEnquireThePersonalOffer = (data) => {
  return {
    type: SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD,
    data,
  };
};

export const fetchNonMfaUserProfile = () => ({
  type: FETCH_NON_MFA_USER_PROFILE,
});

export const updateNonMfaWhatsAppOptIn = (optIn) => ({
  type: UPDATE_NON_MFA_WHATSAPP_OPTIN,
  optIn,
});

export const getOtpNonMFAUser = (phoneNumber) => {
  return {
    type: GET_OTP_NON_MFA_USER,
    phoneNumber,
  };
};

export const verifyOtpNonMFAUser = (otp) => {
  return {
    type: VERIFY_OTP_NON_MFA_USER,
    otp,
  };
};

export const setNonMFAUserMobileNumber = (data) => {
  return {
    type: SET_NON_MFA_USER_MOBILE_NUMBER,
    data,
  };
};

export const setNonMFAUserData = (data) => {
  return {
    type: SET_NON_MFA_USER_DATA,
    data,
  };
};

export const setNonMfaAlert = (data) => {
  return {
    type: SET_NON_MFA_ALERT,
    data,
  };
};

export const resetNonMfaAlert = (data) => {
  return {
    type: RESET_NON_MFA_ALERT,
    data,
  };
};

export const nonMfaUserVerified = (data) => {
  return {
    type: NON_MFA_USER_VERIFICATION_SUCCESS,
    data,
  };
};

export const nonMfaUserSubmitOffer = (data) => {
  return {
    type: NON_MFA_USER_SUBMIT_OFFER,
    data,
  };
};

export const setSelectedOffernonMfaUser = (data) => {
  return {
    type: SET_SELECTED_OFFER_NON_MFA_CUSTOMER,
    selectedOffer: data,
  };
};

export const showHideAlertAction = (data) => {
  return {
    type: SET_CUSTOM_ALERT,
    message: data,
  };
};

export const setViewForOffers = (data) => {
  return {
    type: SET_OFFERS_VIEW,
    viewName: data,
  };
};
export const setEnquiryStatusForOffers = ({data}) => {
  return {
    type: SET_OFFERS_SUBMIT,
    data: data,
  };
};

export const setViewForNonMFA = (data) => {
  return {
    type: NON_MFA_SET_VIEW,
    viewName: data,
  };
};

export const loadUserTokenAction = (customerId) => {
  return {
    type: LOAD_USER_DEVICE_PUSH_TOKEN,
    customerId,
  };
};

export const showEnablePushNotificationModel = (data) => {
  return {
    type: ASK_USER_TO_ENABLE_PUSH,
    data,
  };
};

export const updateWhatsAppOptInDetailsAction = (data) => {
  return {
    type: UPDATE_WHATSAPP_OPT_IN_DETAILS,
    data,
  };
};

export const updatePopupSeenRequestAction = () => {
  return {
    type: UPDATE_POPUP_SEEN_REQUEST,
  };
};

export const getCompletePaymentHistory = () => {
  return {
    type: GET_ACCOUNTING_PAYMENT_HISTORY,
  };
};
